/** 系统模块定义注册 */
import { systemDefine } from "@api";
import { message } from 'ant-design-vue'

/**
 * 将模块定义注册到Vue原型对象
 */
async function prototypeRegister(Vue){
  //获取定义配置
  let res
  try {
    res = await systemDefine()
  } catch (error) { message.error("获取系统模块定义异常！") }
  //转换为对象类型 方便使用
  let sysDefine = Object.fromEntries(res.data.map(item => {
    //字段定义列表转换为对象类型 方便使用
    if(item.fieldList) item.field = Object.fromEntries(item.fieldList.map(field => [field.code, field]))
    //暂时用不到
    // //页签定义列表转换为对象类型 方便使用
    // if(item.tabList) item.tab = Object.fromEntries(item.tabList.map(tab => [tab.code, tab]))
    // //按钮定义列表转换为对象类型 方便使用
    // if(item.btnList) item.btn = Object.fromEntries(item.btnList.map(btn => [btn.code, btn]))
    return [item.moduleCode, item]
  }))
  //将定义配置设置到原型对象
  Vue.prototype.$sysDefine = sysDefine
  //获取字段定义相关方法
  Vue.prototype.$sysDefineField = (fieldCode, moduleCode) => {
    if (!fieldCode || !moduleCode) return null
    return Vue.prototype.$sysDefine?.[moduleCode]?.field?.[fieldCode]
  }
  Vue.prototype.$sysDefineFieldName = (fieldCode, moduleCode) => {
    return Vue.prototype.$sysDefineField(fieldCode, moduleCode)?.fieldName
  }

  //暂时用不到
  // //获取页签定义相关方法
  // Vue.prototype.$sysDefineTab = (tabCode, moduleCode) => {
  //   if (!tabCode || !moduleCode) return null
  //   return Vue.prototype.$sysDefine?.[moduleCode]?.tab?.[tabCode]
  // }
  // Vue.prototype.$sysDefineTabName = (tabCode, moduleCode) => {
  //   return Vue.prototype.$sysDefineTab(tabCode, moduleCode)?.tabName
  // }
  // Vue.prototype.$sysDefineTabEnable = (tabCode, moduleCode) => {
  //   return Vue.prototype.$sysDefineTab(tabCode, moduleCode)?.enable
  // }
  // //获取按钮定义相关方法
  // Vue.prototype.$sysDefineBtn = (fieldCode, moduleCode) => {
  //   if (!fieldCode || !moduleCode) return null
  //   return Vue.prototype.$sysDefine?.[moduleCode]?.btn?.[fieldCode]
  // }
}

export default {
  async install(Vue){
    //将模块定义注册到Vue原型对象
    await prototypeRegister(Vue)
  }
}